const STYLES = {
  da_verificare: { cls: 'bg-red-600 text-white', label: 'Ayvens: da verificare' },
  approvato: { cls: 'bg-emerald-600 text-white', label: 'Ayvens: approvato' },
  rifiutato_ownership: { cls: 'bg-black text-white', label: 'Ayvens: altro operatore' },
};

export const AYVENS_STATUS_LABELS = {
  da_verificare: 'Da verificare',
  approvato: 'Approvato',
  rifiutato_ownership: 'Rifiutato (altro operatore)',
};

export const AyvensStatusBadge = ({ status, testId }) => {
  const s = STYLES[status] || { cls: 'bg-slate-200 text-slate-600', label: 'Ayvens: questionario mancante' };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${s.cls}`} data-testid={testId}>
      {s.label}
    </span>
  );
};
